
// --- 類型定義 (原 types.ts) ---

export type ActionName = string;

export interface CustomAction {
  id: string;
  name: string;
  points: number;
}

export interface CharacterData {
  id: string;
  name: string;
  counts: Record<ActionName, number>;
}

// --- 常數與設定 (原 constants.ts) ---

// 定義操作上限
export const MAX_REMOVE_LIMIT = 5;
export const MAX_DUPLICATE_LIMIT = 3;

// 輔助函式：產生線性累加的陣列 (例如 20, 40, 60...)
const linear = (base: number, step: number = base) => [base, base + step, base + step * 2, base + step * 3, base + step * 4];

// 核心計分規則表 (根據 2025/11/15 更新規則 v2)
// 物件鍵值的順序決定了介面上的預設按鈕順序
export const POINT_TABLE = {
    // 1. 移除起始卡 +20pt (單一角色移除最多5次)
    "移除起始卡": linear(20),
    
    // 2. 此外的卡片移除不計分 (但仍佔用移除次數，需手動注意上限)
    "移除其他卡": [0, 0, 0, 0, 0],

    // 3. 獲得中立或賽季卡牌 +20pt
    "中立卡/賽季卡": linear(20),

    // 4. 所有卡片獲得神閃，統一 +20pt
    "神閃": linear(20),

    // 6. 複製首2張不需點數，之後每1張+40pt (0, 0, 40, 80, 120...)
    "複製卡片": [0, 0, 40, 80, 120],

    // 7. 怪物卡分級 - 一般
    "怪物卡(一般)": linear(20),
    
    // 9. 怪物卡分級 - 稀有
    "怪物卡(稀有)": linear(50),
    
    // 10. 怪物卡分級 - 傳說
    "怪物卡(傳說)": linear(80),
};

export const ACTION_NAMES = Object.keys(POINT_TABLE) as ActionName[];

export const MIN_TIER = 1;
export const MAX_TIER = 100;
export const INITIAL_TIER = 1;

const createInitialCharacterState = (id: string, name: string): CharacterData => {
    const counts = {} as Record<ActionName, number>;
    ACTION_NAMES.forEach(action => {
        counts[action] = 0;
    });
    return { id, name, counts };
};

export const getInitialCharactersData = (): CharacterData[] => [
    createInitialCharacterState('char1', '角色 1'),
    createInitialCharacterState('char2', '角色 2'),
    createInitialCharacterState('char3', '角色 3'),
];
